import { render, staticRenderFns } from "./CustomAttributeDropDown.vue?vue&type=template&id=504bb362&scoped=true&"
import script from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDown.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDown.vue?vue&type=style&index=0&id=504bb362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504bb362",
  null
  
)

export default component.exports